import React from "react";

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <div className="bg-white p-8 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Terms of Service
        </h1>
        <p className="text-gray-600 mb-6">
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-600">
              By accessing or using our services, you agree to be bound by these
              Terms of Service. If you do not agree, you may not use our
              services.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              2. Description of Service
            </h2>
            <p className="text-gray-600">
              We provide [brief description of your service]. The features and
              functionality may change over time.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              3. User Responsibilities
            </h2>
            <p className="text-gray-600">
              You agree to:
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account</li>
                <li>Use the service only for lawful purposes</li>
                <li>Not interfere with or disrupt the service</li>
              </ul>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              4. Intellectual Property
            </h2>
            <p className="text-gray-600">
              All content and materials available on our service are our
              property or the property of our licensors and are protected by
              intellectual property laws.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              5. Limitation of Liability
            </h2>
            <p className="text-gray-600">
              We shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages resulting from your use of or
              inability to use the service.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              6. Termination
            </h2>
            <p className="text-gray-600">
              We may terminate or suspend your access to the service
              immediately, without prior notice, for any reason, including if
              you breach these Terms.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              7. Changes to Terms
            </h2>
            <p className="text-gray-600">
              We reserve the right to modify these Terms at any time. Your
              continued use of the service constitutes acceptance of the
              modified Terms.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              8. Governing Law
            </h2>
            <p className="text-gray-600">
              These Terms shall be governed by and construed in accordance with
              the laws of [Your Country/State], without regard to its conflict
              of law provisions.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              9. Contact Us
            </h2>
            <p className="text-gray-600">
              If you have any questions about these Terms, please contact us at
              legal@yourcompany.com.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
